var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSlovenia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 10.4457H13.9131V6.27173H5.56519V10.4457H0.995188C0.352063 12.1789 0 14.0537 0 16.0109C0 17.968 0.352063 19.8427 0.995188 21.576L16 22.9674L31.0048 21.576C31.6479 19.8427 32 17.968 32 16.0109C32 14.0537 31.6479 12.1789 31.0048 10.4457Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C22.8794 32.0107 28.7441 27.6687 31.0048 21.5759H0.995178C3.25587 27.6687 9.12055 32.0107 16 32.0107Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56519 10.4456V11.8369C5.56519 15.0319 9.73912 16.0109 9.73912 16.0109C9.73912 16.0109 13.9131 15.0319 13.9131 11.8369V10.4456L12.5217 11.8369L9.73912 9.75L6.9565 11.8369L5.56519 10.4456Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSlovenia);
export default __webpack_public_path__ + "static/media/flag_slovenia.71858f5d1b39e328551defb5e704c147.svg";
export { ForwardRef as ReactComponent };